import { EventEmitter } from 'events';

import { get } from 'jquery';

import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { MULTICAST_MAX_RETRIES, multicastXhrConfig, removeQueryStr } from '../MulticastHlsUtil';

import { IMasterPlaylistData } from './IMasterPlaylistData';
import { MasterPlaylistParser } from './MasterPlaylistParser';

export const MPL_PLAYLIST_PARSED = 'playlistParsed';
export const MPL_PLAYLIST_PARSING_ERROR = 'playlistParsingError';
export const MPL_PLAYLIST_LOAD_ERROR = 'playlistLoadError';
const MPL_NUM_RETRIES = 2;

export class MasterPlaylistLoader extends EventEmitter {
	public isActive: boolean;

	private headers: { [key: string]: string };
	private numRetries: number = MPL_NUM_RETRIES;
	private retryCount: number;
	private _updateTimeoutRef: number;
	private withCredentials: boolean;

	constructor(
		API: VideogularComponent,
		private src: string,
		isMulticast: boolean,
		private updateIntervalSecs: number = 0
	) {
		super();

		this.isActive = false;
		this.retryCount = 0;

		const { tokenConfig } = API.activeSource;
		this.withCredentials = !!(tokenConfig && tokenConfig.withCredentials);

		if (isMulticast) {
			this.headers = multicastXhrConfig(src).additionalHeaders;
			this.numRetries = MULTICAST_MAX_RETRIES;

			this.src = removeQueryStr(src);
		}
	}

	public start(): void {
		if (!this.isActive) {
			this.isActive = true;
			this._updateTimeoutRef = null;

			this.loadAndParsePlaylist();
		}
	}

	public stop(): void {
		this.isActive = false;

		if (this._updateTimeoutRef) {
			window.clearTimeout(this._updateTimeoutRef);
		}
	}

	private loadAndParsePlaylist(): void {
		get({
			url: this.src,
			beforeSend(xhr) {
				xhr.overrideMimeType('text/plain');
			},
			headers: this.headers,
			xhrFields: {
				withCredentials: this.withCredentials
			}
		})
			.then(response => {
				if (this.isActive) {
					const parsedPlaylist: IMasterPlaylistData = MasterPlaylistParser.parse(this.src, response, this.headers);

					if (parsedPlaylist) {
						this.emit(MPL_PLAYLIST_PARSED, parsedPlaylist);

						if (parsedPlaylist.isContentTrackedInMasterPlaylist && this.updateIntervalSecs) {
							this._updateTimeoutRef = window.setTimeout(() => this.loadAndParsePlaylist(), this.updateIntervalSecs * 1000);
						}
					} else {
						this.emit(MPL_PLAYLIST_PARSING_ERROR);
					}
				}

				this.retryCount = 0;
			})
			.catch(ex => {
				console.info(ex);

				if (!this.isActive) {
					return;
				}

				if (this.retryCount === this.numRetries) {
					this.emit(MPL_PLAYLIST_LOAD_ERROR);
				} else {
					++this.retryCount;

					console.warn(`Retry master playlist load #${this.retryCount}`);

					this._updateTimeoutRef = window.setTimeout(() => this.loadAndParsePlaylist(), 500);
				}
			});
	}
}
